<div *ngIf="product != null; else loading">
  <div class="row">
    <div class="col-xs-12 col-sm-6">
      <img
        [src]="'https://cdn1.gung.io/fit-in/400x400/' + product.extra.images[0].s3Uri"
        alt="Product image"
        class="img-fluid"
      />
    </div>
    <div class="col-xs-12 col-sm-6">
      <lib-availability [availability]="availability"></lib-availability>
      <h3><span translate>ITEM_NO</span>: {{ product.id }}</h3>
      <h2>
        <b>{{ product.name }}</b>
      </h2>
      <!-- <h5 class="product-title">{{ product.name }} - {{ product.id }}</h5> -->
      <p>{{ product.description }}</p>
      <h4>
        <span *ngIf="price">
          <span *ngIf="price.customerDiscountPercent === 0" class="mr-1" translate>NET_PRICE</span>
          <lib-price
            *ngIf="price.customerDiscountPercent === 0; else netPrice"
            [price]="price"
            type="NET"
          ></lib-price>
          <ng-template #netPrice>
            <lib-price
              [price]="price"
              type="GROSS"
            ></lib-price>
          </ng-template>
          <span *ngIf="price.customerDiscountPercent !== 0" class="ml-1">(-{{ price.customerDiscountPercent }}%)</span>
        </span>

        <i
          *ngIf="isAdminOrSales && product.extra?.ar?.artkalkpris"
          class="fa-light fa-circle-info cursor-pointer tooltip-size"
          placement="top"
          ngbTooltip="{{ 'COST' | translate}}: {{ (product.extra?.ar?.artkalkpris || 0) | gungCurrency:'SEK' }}">
        </i>
      </h4>

      <div class="col-12 table-responsive">
        <table class="table table-borderless table-sm">
          <tbody>
            <tr>
              <th translate>PACKAGE_SIZE</th>
              <td>
                {{ product.extra.ar.artfsgforp }}
              </td>
            </tr>
            <tr *ngIf="product.extra.ar.enhetskod">
              <th translate>UNIT</th>
              <td translate>
                {{ product.extra.ar.enhetskod }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12" *ngIf="!isOnlyDisplayFlow">
        <div *ngIf="isCapstone; else otherProject">
          <lib-buy-btn [id]="product.id"> </lib-buy-btn>
        </div>

        <ng-template #otherProject>
          <lib-buy-btn
            [id]="product.id"
            [minimumOrderQuantity]="product.extra.ar.artfsgforp"
            [stepAmount]="product.extra.ar.artfsgforp"
          >
          </lib-buy-btn>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col">
      <lib-gung-tabset>
        <lib-gung-tab *ngIf="!!addonIds && addonIds.length > 0" [title]="'ADDONS' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [productIds]="addonIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="product.extra.pdm && product.extra.pdm.length > 0" [title]="'DOCUMENTS' | translate">
          <ng-template libGungTabContent>
            <div class="row">
              <div class="col table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th translate>NAME</th>
                      <th class="text-right" translate>DOWNLOAD_DOCUMENT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of product.extra.pdm">
                      <td>
                        {{ document.docdescr }}
                      </td>
                      <td class="text-right">
                        <a
                          target="_NEW"
                          [href]="
                            'https://cdn2.gung.io/capstone/' +
                            document.pdmdummyuniqueid +
                            document.documentext
                          "
                        >
                          {{ document.pdmdummyuniqueid }}{{ document.documentext }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
</div>

<ng-template #loading> LOADING... </ng-template>
